import React, { useEffect, useState } from "react";
import {
  CancelButton,
  UpdateButton,
} from "../../../components/mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Stack,
  TextField,
} from "@mui/material";
import GlobalDialog from "../../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../../components/mui/GlobalSelectField";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import {
  getAllBrands,
  getCategoryTypes,
  updateBrand,
  updateCategoryTypes,
} from "../../../redux/features/assetManagementSlice";

const EditType = ({ rowData, dispatchParams }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading } = useSelector((state) => state.assetmanagement);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      category_type_id: rowData.category_type_id,
      category_type_name: rowData.category_type_name,
      is_returnable: rowData.is_returnable,
    },
    onSubmit: (values) => {
      dispatch(updateCategoryTypes({ data: [values] })).then((res) => {
        console.log(res);
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          formik.resetForm();
          dispatch(getCategoryTypes(dispatchParams));
          setOpen(false);
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          // setOpen(false);
        }
      });
    },
  });

  return (
    <GlobalDialog
      title={"Update Type"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"sm"}
      closeButton={true}
      popupButton={
        <UpdateButton size="medium" action={() => setOpen(true)}>
          Update
        </UpdateButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <TextField
                    name="category_type_name"
                    value={formik.values.category_type_name}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Type Name"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="is_returnable"
                        checked={formik.values.is_returnable}
                        onChange={formik.handleChange}
                      />
                    }
                    label="Is Returnable"
                  />
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <UpdateButton disabled={loading} size="small" type="submit">
                      {loading ? "Please wait..." : "Update"}
                    </UpdateButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default EditType;
